import type { ReactNode } from "react";
import { ScrollView, View, type ViewStyle } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { layout, spacing, useTheme } from "~/styles/theme";

/**
 * A full-height screen whose content sits in a centred column (never edge to
 * edge on desktop web). `maxWidth` defaults to the modal/form width; pass
 * `layout.pageMaxWidth` for dashboard-style screens. The column carries no
 * horizontal padding in the non-scroll case — children (header, scroll body)
 * set their own, so rules and text line up.
 */
export function Screen({
  children,
  scroll = false,
  style,
  maxWidth = layout.modalMaxWidth,
}: {
  children: ReactNode;
  scroll?: boolean;
  style?: ViewStyle;
  maxWidth?: number;
}) {
  const { colors } = useTheme();
  return (
    <SafeAreaView
      style={{ flex: 1, backgroundColor: colors.background }}
      edges={["top", "left", "right"]}
    >
      <View style={{ flex: 1, width: "100%", maxWidth, alignSelf: "center" }}>
        {scroll ? (
          <ScrollView
            contentContainerStyle={[
              { paddingHorizontal: spacing.lg, paddingBottom: spacing.xxl },
              style,
            ]}
          >
            {children}
          </ScrollView>
        ) : (
          <View style={[{ flex: 1 }, style]}>{children}</View>
        )}
      </View>
    </SafeAreaView>
  );
}
